import { InfoblockActions } from '../actions';
import { InfoblockState } from '../infoblock-state';

export const initialState: InfoblockState['closed'] = [];

export function reducer(state = initialState, action: InfoblockActions.CloseInfoblocks): InfoblockState['closed'] {
  switch (action.type) {
    case InfoblockActions.CLOSE_INFOBLOCKS: {
      return [...new Set([...state, ...action.payload])];
    }

    default: {
      return state;
    }
  }
}
